module.exports = __webpack_public_path__ + "static/media/casey_burden.52493f9e.jpg";